import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';

type PackageTypeWithFreeVariation = 'premium' | 'unlimited';

export const createReportFreeVariation =
    (location: string) => (packageType: PackageTypeWithFreeVariation) => {
        mixpanel.track('Logo Maker - Get Free Variation', {
            [MIXPANEL_EVENT_PROPERTIES.PACKAGE_TYPE]: packageType,
            [MIXPANEL_EVENT_PROPERTIES.LOCATION]: location,
        });
    };
